import { defineMessages, FormattedMessage } from 'react-intl';

import { commonMessages } from '@/messages/common';

const prefix = 'addToBagDialog';

export const AddedToShoppingBag = (
  <FormattedMessage
    defaultMessage='Added to shopping bag'
    id={`${prefix}.addedToShoppingBag`}
  />
);

export const VATIncluded = (
  <FormattedMessage defaultMessage='VAT Incl.' id={`${prefix}.vatIncluded`} />
);

export const VATExcluded = <FormattedMessage {...commonMessages.vatIncl} />;

export const messages = defineMessages({
  view: {
    defaultMessage: 'View ({itemCount})',
    id: `${prefix}.view`,
  },
  shoppingBag: {
    defaultMessage: 'Shopping Bag',
    id: `${prefix}.shoppingBag`,
  },
});

export const ShoppingBag = (
  <FormattedMessage
    defaultMessage='Shopping Bag'
    id={`${prefix}.shoppingBag`}
  />
);

export const ViewShoppingBagDetail = (
  <FormattedMessage
    defaultMessage='View Shopping Bag Detail'
    id='checkout.addPopin.view'
  />
);
